import React, {useEffect, useMemo, useState} from 'react';
import {classes, style} from './doppe-viewer-auto-redirect-notification-content.st.css';
import {stringTrimPrefix, urlGetHostname} from '@wix/devzai-utils-common';
import {useRenderState} from '@wix/devzai-utils-react';
import {
    DoppeViewerAutoRedirectSettings
} from "../doppe-viewer-auto-redirect-settings/doppe-viewer-auto-redirect-settings";
import {DoppeViewerAttributionLink, SourceType} from '../doppe-viewer-attribution-link/doppe-viewer-attribution-link';
import {useDoppeViewerLangDictionary} from '../doppe-viewer-lang-dictionary/doppe-viewer-lang-dictionary';

export const DoppeViewerAutoRedirectNotificationContent = React.memo(function DoppeViewerAutoRedirectNotificationContent(props: DoppeViewerAutoRedirectNotificationContent.Props) {
    const {
        showCancelButton = true,
        countdownSeconds = 3,
        additionalMessage = '',
        targetUrl,
        onCountdownComplete,
        onCancel,
        showCreatedByHopp = false,

        className,
        ...htmlAttributes
    } = props;

    const [countdown, setCountdown] = useState(countdownSeconds);

    const renderState = useRenderState({
        onCountdownComplete
    });

    const normalizedAdditionalMessage = additionalMessage.trim();

    useEffect(() => {

        const countdownInterval = setInterval(() => {
            setCountdown(countdown => {
                const updatedCountdown = countdown - 1;

                if (updatedCountdown === 0) {
                    clearInterval(countdownInterval);

                    setTimeout(() => {
                        renderState.current.onCountdownComplete?.();
                    })
                }

                return updatedCountdown;
            })
        }, 1000);

        return () => {
            clearInterval(countdownInterval)
        }
    }, []);

    const normalizedHostName = useMemo(() => stringTrimPrefix(urlGetHostname(targetUrl), 'www.'), [targetUrl]);

    const doppeViewerLangDictionary = useDoppeViewerLangDictionary();

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            <div
                className={style(classes.contentRow, {})}
            >
                {
                    normalizedAdditionalMessage !== '' ?
                        (
                            <div
                                className={style(classes.additionalMessage, {})}
                            >
                                {normalizedAdditionalMessage}
                            </div>
                        ) :
                        null
                }
                <div className={style(classes.redirectingMessage, {})}>
                    {doppeViewerLangDictionary.autoRedirectBannerRedirectingText({
                        normalizedHostName,
                        countdown,
                    })}
                </div>
                {showCreatedByHopp ? (
                    <DoppeViewerAttributionLink
                        className={style(classes.createdByHoppAttribution, {})}
                        sourceType={SourceType.PreRoll}
                    >
                        {doppeViewerLangDictionary.createdWithHopp}
                        <span className={style(classes.brandAttribution, {})}>{` hopp.co`}</span>
                    </DoppeViewerAttributionLink>
                ) : null}
            </div>
            {
                showCancelButton ?
                    <button
                        className={style(classes.cancelButton, {})}
                        onClick={onCancel}
                    >
                        {doppeViewerLangDictionary.autoRedirectBannerRedirectingCancelText}
                    </button>
                    :
                    null
            }

        </div>
    );
});

export namespace DoppeViewerAutoRedirectNotificationContent {

    export interface Props extends DoppeViewerAutoRedirectSettings, React.HTMLAttributes<any> {
        showCreatedByHopp?: boolean;
    }
}
